import { useState, useEffect } from 'react';
import { SignupSelectPage } from './auth/SignupSelectPage';
import { DesktopSignupSelectPage } from './desktop/DesktopSignupSelectPage';

export function ResponsiveSignupSelectPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SignupSelectPage /> : <DesktopSignupSelectPage />;
}